import type { CustomerInfo, CommonStatusUILabel } from '@@partner:types:app'
import type { CustomersFiltersType } from '@components/customers/grid/CustomersFilter'

import { formatCustomerStatus } from '@@partner:helpers/formatters/customer'
import { makeFilter, makeSearchFilter } from '@@partner:helpers/crud/filters'

import {
  CUSTOMER_STATUS_DISABLED,
  CUSTOMER_STATUS_ENABLED,
  CUSTOMER_STATUS_DELETED
} from '@@partner:config/customer'

interface CustomerStatusUISettings extends CommonStatusUILabel {
  value: number
}

export function getSearchableCustomerStatus (): CustomerStatusUISettings[] {
  const SEARCHABLE_CUSTOMER_STATUS = [
    CUSTOMER_STATUS_DISABLED,
    CUSTOMER_STATUS_ENABLED,
    CUSTOMER_STATUS_DELETED
  ]

  return SEARCHABLE_CUSTOMER_STATUS.map((statusCode) => {
    const statusConfig = formatCustomerStatus(statusCode)

    return {
      value: statusCode,
      label: statusConfig.label,
      color: statusConfig.color
    }
  })
}

export const prepareCustomersFilter = (filters: CustomersFiltersType) => {
  const statusFilter = makeFilter('status', 'contains', filters.status)
  const searchFirstNameFilter = makeSearchFilter(
    'first_name',
    'starts_with',
    filters.first_name
  )
  const searchLastNameFilter = makeSearchFilter(
    'last_name',
    'starts_with',
    filters.last_name
  )
  const searchPhoneFilter = makeSearchFilter(
    'phone',
    'starts_with',
    filters.phone
  )

  const searchEmailFilter = makeSearchFilter(
    'receipt_email',
    'starts_with',
    filters.receipt_email
  )

  return {
    and: [
      statusFilter,
      searchFirstNameFilter,
      searchLastNameFilter,
      searchPhoneFilter,
      searchEmailFilter
    ]
  }
}
